import React, { useCallback, useEffect, useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Stack, Grid } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/api'
import SuccessMessage from "../components/successMessage";
import ErrorMessage from "../components/errorMessage";
import Loading from '../components/loading';

function PrintSettings() {
    
    const navigate = useNavigate();

    const [settings, setSettings] = useState({
        observacaoUm: '',
        tituloUm: '',
        conteudoUm: '',
        nomeDaClinica: '',
        nomeDaCidade: '',
        email: '',
        telefone: ''
    });

    const [isLoading, setIsLoading] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const getPrintSettings = useCallback(() => {
        setIsLoading(true);
        api.get('/impressao/campos-do-tratamento', {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then(returnFromApi => {
            if (returnFromApi.data) {
                setSettings(prev => ({ ...prev, ...returnFromApi.data }));
            }
        }).catch(returnFromApi => {
            console.error("ops! ocorreu um erro" + returnFromApi);
            if (returnFromApi.status === 401) {
                navigate("/expired-session");
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [navigate]);

    useEffect(() => {
        getPrintSettings();
    }, [getPrintSettings]);

    const saveSettings = (event) => {
        event.preventDefault();
        setIsLoading(true);
        setShowSuccessMessage(false);
        setShowErrorMessage(false);

        api.put('/impressao/campos-do-tratamento', settings, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
            .then(returnFromApi => {

                setShowSuccessMessage(true);
                setSuccessMessage(returnFromApi.data);
            })
            .catch((err) => {
                setShowErrorMessage(true);
                setErrorMessage(err.response.data);
                console.error("ops! ocorreu um erro" + err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    return (
        <>
            <Loading isToHidden={isLoading === false} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 4 }}>
                <Typography variant="h5" component="h1" fontWeight="bold" gutterBottom>
                    Configurações dos campos para impressão de tratamento
                </Typography>

                <Box sx={{ mt: 4 }}>
                    <Paper component="form" onSubmit={saveSettings} sx={{ p: 4 }}>
                        <Stack spacing={3}>
                            <TextField
                                name="observacaoUm"
                                label="Observação Um"
                                multiline
                                rows={4}
                                value={settings.observacaoUm}
                                onChange={(e) => setSettings({ ...settings, observacaoUm: e.target.value })}
                            />
                            <TextField
                                name="tituloUm"
                                label="Título Um"
                                multiline
                                rows={4}
                                value={settings.tituloUm}
                                onChange={(e) => setSettings({ ...settings, tituloUm: e.target.value })}
                            />
                            <TextField
                                name="conteudoUm"
                                label="Conteúdo Um"
                                multiline
                                rows={4}
                                value={settings.conteudoUm}
                                onChange={(e) => setSettings({ ...settings, conteudoUm: e.target.value })}
                            />
                            <TextField
                                name="nomeClinica"
                                label="Nome da Clínica"
                                value={settings.nomeDaClinica}
                                onChange={(e) => setSettings({ ...settings, nomeDaClinica: e.target.value })}
                            />

                            <Grid container spacing={3}>
                                <Grid size={12}>
                                    <TextField
                                        name="cidade"
                                        label="Cidade"
                                        fullWidth
                                        value={settings.nomeDaCidade}
                                        onChange={(e) => setSettings({ ...settings, nomeDaCidade: e.target.value })}
                                    />
                                </Grid >
                                <Grid size={12}>
                                    <TextField
                                        name="email"
                                        label="Email"
                                        fullWidth
                                        value={settings.email}
                                        onChange={(e) => setSettings({ ...settings, email: e.target.value })}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <TextField
                                        name="telefone"
                                        label="Telefone"
                                        fullWidth
                                        value={settings.telefone}
                                        onChange={(e) => setSettings({ ...settings, telefone: e.target.value })}
                                    />
                                </Grid>
                            </Grid>

                            <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
                                <Button
                                    variant="outlined"
                                    component={Link}
                                    to="/home"
                                    disabled={isLoading}
                                > Cancelar
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={isLoading}
                                > Salvar
                                </Button>
                            </Stack>
                        </Stack>
                    </Paper>
                </Box>
            </Box>
        </>
    );
}

export default PrintSettings;